import { Types } from "../actions/assetActions";
import _ from "lodash";

const assetReducers = (state, action) => {

  switch (action.type) {
    case Types.ASSET_SAVED: {
      let newState = _.cloneDeep(state);

      newState.asset.item = action.payload
      newState.asset.saving = undefined

      return newState;
    }

    case Types.ASSET_SAVING: {
      let newState = _.cloneDeep(state)

      newState.asset.saving = true

      return newState
    }

    case Types.ASSET_AUDIT_LOGS: {

      let newState = _.cloneDeep(state);

      newState.asset.auditLogs = {
        items: action.extend && newState.asset.auditLogs ? [...newState.asset.auditLogs.items, ...action.payload.items] : action.payload.items,
        nextToken: action.payload.nextToken,
        count: action.extend ? (newState.asset.auditLogs && newState.asset.auditLogs.count || 0) + action.payload.count : action.payload.count,
      }

      return newState;
    }

    case Types.ASSET_CLEAR: {
      let newState = _.cloneDeep(state)
      newState.asset.item = undefined
      newState.asset.auditLogs = undefined
      return newState
    }

    case Types.ASSET_NEW_MODAL: {
      let newState = _.cloneDeep(state)
      newState.asset.newModal = action.toggle ? true : undefined
      return newState
    }

    case Types.ASSET_ASSIGN_MODAL: {
      let newState = _.cloneDeep(state)
      newState.asset.assignModal = action.toggle ? true : undefined
      return newState
    }
    case Types.ASSET_UNASSIGN_MODAL: {
      let newState = _.cloneDeep(state)
      newState.asset.unassignModal = action.toggle ? true : undefined
      return newState
    }

    case Types.ASSET_TAB: {

      let newState = _.cloneDeep(state);

      newState.asset.tab = action.tab

      return newState;
    }
    case Types.ASSET_LIST: {

      let newState = _.cloneDeep(state);

      newState.asset.list = action.payload?.map(item => {
        const currentEmployee = newState.employees?.employeeListWithSalary?.find(employee => employee.id === item?.agreement)
        const employeeName = currentEmployee ? `${currentEmployee?.employeeName} ${currentEmployee?.employeeSurname}` : undefined

        return ({
          ...item,
          employeeName
        })
      })

      return newState;
    }
    case Types.ASSET_HISTORY: {

      let newState = _.cloneDeep(state);

      newState.asset.item.history = action.payload

      return newState;
    }
    case Types.ASSET_GET: {

      let newState = _.cloneDeep(state);

      newState.asset.item = action.payload

      return newState;
    }
    default:
      return state;
  }
};

export default assetReducers;
